<template>
  <ul :class="itemClass" v-if="checkRouterAccess()">
    <li class="dashboard" v-b-toggle="`collapse-${id}`" @click="customAction">
      <router-link :to="route">

        <b-icon :icon="icon"></b-icon>
        {{ name }}
        <b-icon v-if="children.length>0" icon="arrow-down-circle" class="d-inline"></b-icon>
      </router-link>

    </li>

    <SubItem v-if="children.length"
             :id="id"
             :step="1"
             :children="children"
    />

  </ul>
</template>

<script>
import SubItem from './subItem'
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import {mapGetters} from "vuex";

export default {
  name: "item",
  components: {SubItem},
  props: ['name', 'icon', 'route', 'children', 'id', 'action', 'access', 'itemClass'],
  computed:{
    ...mapGetters({
      isStore:"User/isUserStore"
    })
  },
  methods: {
    customAction() {
      if (this.action !== undefined) {
        this.action()
      }
    },
    checkRouterAccess() {
      let userProfile = this.$store.getters['User/getProfile'];

      if (findAttributeOnSiteInfo('store_access_to_content_management')[0] == 1 && this.name == 'مدیریت محتوا' && this.isStore) {
        return false
      }

      if (this.access.length === 0) {
        return true
      }
      let userAccessNumber = `${userProfile.role}-${userProfile.type}`
      return this.access.indexOf(userAccessNumber) > -1
    }
  }
}
</script>

<style scoped>
.dashboard {
  padding-top: 2rem;
  padding-right: 1rem;
  text-align: right;
  text-decoration: none;
  cursor: pointer;
}


ul li {
  list-style: none;
}


ul li a {
  color: #000;
  text-decoration: none;
  display: block;
  padding: 15px 0 15px 10px;
  font-size: 18px;
  outline: none;
}

@media only screen and (max-width: 991px) {
  ul li a {
    color: #fff;
  }
}


</style>